import React, { Component } from 'react';
// import { ArcMapView } from 'arcgis-react';
import { Map } from '@esri/react-arcgis'
import Points from './Points';
import { Loader } from '../../../components/Loader';
import { loadCss } from 'esri-loader';

class CustomMap extends Component<any, any> {
  render() {
    // by default loadCss() loads styles for the latest 4.x version
    loadCss();
    return (
      // <ArcMapView
      // style={{width: '100%', height: '80vh'}}
      // map={{
      //   basemap: 'streets-navigation-vector'
      // }}
      // center={[this.props.mapView.latitude, this.props.mapView.longitude]}
      // zoom={this.props.mapView.zoom}>
      //   {/* <Points points={this.props.data} year={this.props.year} mapView={this.props.mapView} currentBarcode={this.props.currentBarcode} /> */}
      // </ArcMapView>

<Map
  style={{ width: '100%', height: '80vh' }}
  loadElement={<Loader title='Loading Map' />}
  mapProperties={{
    basemap: 'streets-navigation-vector',
  }}
  viewProperties={{
    center: [this.props.mapView.latitude, this.props.mapView.longitude],
    zoom: this.props.mapView.zoom,
  }}>
  <Points points={this.props.data} year={this.props.year} mapView={this.props.mapView} currentBarcode={this.props.currentBarcode} />
</Map>
      );
      // return null
    }
  }

export default CustomMap;
